exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#444;font-size:14px;width:100%;height:100%;overflow:hidden}h1{font-size:32px!important}h2{font-size:26px!important}h3{font-size:20px!important}h4{font-size:16px!important}h5{font-size:12px!important;font-size:10px!important}", ""]);

// exports
